module.exports = __webpack_public_path__ + "images/corvette_small25941fc3f8ea3e958d343372f0410447.png";